import { Stack, styled } from '@mui/material';

import { theme } from '@/shared/design-system';

import { SetupContent } from '../two-factor-authentication/modules/setup/totp-setup.styled';

export const DialogContent = styled(Stack)({
  flexDirection: 'column',
  gap: `${theme.spacing[24]}px`,
});

export const CenteredStatus = styled(Stack)({
  alignItems: 'center',
  color: theme.colors.text.secondary,
  gap: `${theme.spacing[12]}px`,
  textAlign: 'center',
});

export const WalletTotpSetupContent = styled(SetupContent)({
  height: 'auto',
  overflowY: 'visible',
});

export const KeySavedConfirmation = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: `${theme.spacing[8]}px`,
});

export const KeyBackupActions = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${theme.spacing[8]}px`,
});
